export const shadowRoot = document.getElementById("main-content").shadowRoot;
